import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1810e656"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vstack" }
const _hoisted_2 = {
  ref: "chat",
  class: "chat-section"
}
const _hoisted_3 = {
  key: 0,
  class: "input-section"
}
const _hoisted_4 = {
  key: 0,
  class: "typing-indicator"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-secondary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Waiting for response")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Waiting for response", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_message_list = _resolveComponent("message-list")!
  const _component_button_list_input = _resolveComponent("button-list-input")!
  const _component_text_input = _resolveComponent("text-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_message_list, {
        onUpdated: _ctx.updated,
        messages: _ctx.messages
      }, null, 8, ["onUpdated", "messages"])
    ], 512),
    (!_ctx.inputHidden)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_Transition, {
            name: "input-transition",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_ctx.waitingForBotResponse)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7))
                : (_ctx.showReplyBar && !_ctx.waitingForBotResponse)
                  ? (_openBlock(), _createBlock(_component_button_list_input, {
                      key: 1,
                      onUpdated: _ctx.updated
                    }, null, 8, ["onUpdated"]))
                  : (!_ctx.showReplyBar && !_ctx.waitingForBotResponse)
                    ? (_openBlock(), _createBlock(_component_text_input, {
                        key: 2,
                        button: "Send",
                        placeholder: "Enter message"
                      }))
                    : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}